import { render, staticRenderFns } from "./MastheadStoryColorsAndFonts.vue?vue&type=template&id=5688c136&scoped=true&"
import script from "./MastheadStoryColorsAndFonts.vue?vue&type=script&lang=js&"
export * from "./MastheadStoryColorsAndFonts.vue?vue&type=script&lang=js&"
import style0 from "./MastheadStoryColorsAndFonts.vue?vue&type=style&index=0&id=5688c136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688c136",
  null
  
)

export default component.exports